import { StatusModel } from "../../general";

export interface HexagonListModel {
  label: string;
  value: number | string;
  unit: string;
  utilisation: StatusModel;
  isActive?: boolean;
}
